import React from 'react';
import { FormattedMessage } from 'react-intl';
import ActionList from 'Components/ActionList';

interface OrderActionsProps {
  right?: boolean;
  children?: React.ReactNode;
}

const OrderActions: React.FC<OrderActionsProps> = ({ right, children }) => {
  return (
    <ActionList
      className={`tender-actions button nui-button nui-secondary has-dd ${right ? '' : 'left'}`}
      title={
        <FormattedMessage
          id="tender-button-actions"
          description="Button for tender owner actions"
          defaultMessage="Actions"
        />
      }
    >
      {children}
    </ActionList>
  );
};

export default OrderActions;
